import { createBrowserHistory } from 'history';
// creat a browser history, allowing deep integration from within redux
// https://reacttraining.com/react-router/web/api/Router
const history = createBrowserHistory();

export { history };
